export enum RiskRAGStatuses {
  Low = 1,
  Minor = 2,
  Medium = 3,
  High = 4,
  Extreme = 5,
}
